export default __webpack_public_path__ + "static/media/resume_avi.165c7bae.pdf";